import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

//MUI
import {makeStyles} from 'tss-react/mui';

import {createTheme, ThemeProvider} from '@mui/material/styles';

//DS
import PrettyJson from '../../atomicos/PrettyJson';
import ChipList from '../../atomicos/ChipList';
import DialogDS from '../../moleculas/DialogDS';
import DatosAdicionalesAgregar from '../DatosAdicionalesAgregar/DatosAdicionalesAgregar';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   fullWidth: {
      width: '100% !important'
   }
}));

function ChipsDatosAdicionales(props) {
   const {classes, cx} = useStyles();
   const {
      fullWidth,
      datosAdicionales,
      tituloModal,
      campoObligatorio,
      datosAdicionalesAgregarProps,
      infoSugerida,
      columnasDatosAdicionales,
      handleOnChangeDatosAdicionales,
      ...other
   } = props;
   const {
      campoObligatorio: co,
      infoSugerida: is,
      columnasDatosAdicionales: cda,
      titulo,
      ...daaProps
   } = datosAdicionalesAgregarProps;

   const [open, setOpen] = useState(false);
   function openModal() {
      setOpen(true);
   }
   function closeModal() {
      setOpen(false);
      setChipActual({value: null, index: -1});
   }

   const [chipActual, setChipActual] = useState({value: null, index: -1});
   useEffect(() => {
      if (chipActual.index >= 0) {
         openModal();
      }
   }, [chipActual]);

   const onClickChip = (chipValue, index) => {
      setChipActual({value: chipValue, index});
   };

   const onDeleteChip = (chipToDelete) => {
      handleOnChangeDatosAdicionales((chips) =>
         chips.filter((chip) => chip[campoObligatorio.name] !== chipToDelete[campoObligatorio.name])
      );
   };

   function closeModalCallback(data) {
      if (chipActual.index >= 0) {
         let listaActualizada = datosAdicionales;
         listaActualizada[chipActual.index] = data;
         handleOnChangeDatosAdicionales(listaActualizada);
         setChipActual({value: null, index: -1});
         closeModal();
      } else {
         handleOnChangeDatosAdicionales([...datosAdicionales, data]);
         closeModal();
      }
   }

   return (
      <div
         className={cx({
            [classes.fullWidth]: fullWidth
         })}
      >
         <ChipList
            fullWidth
            chips={datosAdicionales}
            onClickAgregar={openModal}
            genChipLabel={(item) => item[campoObligatorio.name]}
            toolTipGenTitle={(item) => (
               <PrettyJson nombreCampoId={campoObligatorio.name} objeto={item} />
            )}
            toolTipProps={{clickable: true, arrow: true}}
            onDeleteChip={onDeleteChip}
            onClickChip={onClickChip}
            {...other}
         />
         <DialogDS open={open} mostrarBotonesAccion={false} onClose={closeModal}>
            <DatosAdicionalesAgregar
               {...daaProps}
               objetoActual={chipActual.value}
               campoObligatorio={campoObligatorio}
               titulo={tituloModal}
               infoSugerida={infoSugerida}
               columnasDatosAdicionales={columnasDatosAdicionales}
               closeModalCallback={closeModalCallback}
               closeModal={closeModal}
            />
         </DialogDS>
      </div>
   );
}

ChipsDatosAdicionales.propTypes = {
   fullWidth: PropTypes.bool,
   datosAdicionales: PropTypes.arrayOf(PropTypes.object),
   tituloModal: PropTypes.string,
   campoObligatorio: PropTypes.shape({name: PropTypes.string, label: PropTypes.string}),
   //datosAdicionalesAgregarProps: PropTypes.arrayOf(PropTypes.object),
   infoSugerida: PropTypes.arrayOf(PropTypes.string),
   columnasDatosAdicionales: PropTypes.arrayOf(PropTypes.string),
   handleOnChangeDatosAdicionales: PropTypes.func
};

ChipsDatosAdicionales.defaultProps = {};

export default ChipsDatosAdicionales;
